import React from 'react';
import * as PropTypes from 'prop-types';

ErrorLayout.propTypes = {
  image: PropTypes.string.isRequired,
  tips: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]),
  onBtnClick: PropTypes.func,
  btnText: PropTypes.string
};

ErrorLayout.defaultProps = {
  tips: '加载失败，请点击重试',
  btnText: '重试'
};

export default function ErrorLayout(
  {
    image,
    tips,
    onBtnClick,
    btnText,
    className,
    ...rest
  }
) {
  return (
    <article className={`error-layout${className ? ` ${className}` : ''}`} {...rest}>
      <div className="error-layout-image">
        <img alt={tips} src={image} />
      </div>
      <div className="error-layout-tips">{tips}</div>
      {
        !!onBtnClick && (
          <div className="error-layout-button" onClick={onBtnClick}>{btnText}</div>
        )
      }
    </article>
  );
}
